import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d40596b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vielen Dank für Ihre Anfrage. Wir werden uns in Kürze bei Ihnen melden.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://erkoware.de/" }, "Zurück zur Homepage", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_budget_field = _resolveComponent("budget-field")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_contact_form = _resolveComponent("contact-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_row, { style: {"padding-top":"20px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_budget_field)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.commitSent)
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 0,
          style: {"padding-top":"30px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              class: "ion-text-center",
              style: {"color":"var(--ion-headline-color)"}
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_contact_form, {
          key: 1,
          onCommitSent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.commitSent = true))
        })),
    (!_ctx.commitSent)
      ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { class: "back-button center cursor-pointer" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backToStart()))
                }, "Zurück zum Start")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.commitSent)
      ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { class: "back-button center cursor-pointer" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}